<template>
  <StaffingAgencyClientRelationLabel
    :is-direct="column.isDirect"
    :managing-company="column.managingCompany"
    :data-test="`agency-client-relation-${rowIndex}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import StaffingAgencyClientRelationLabel from '@/components/StaffingAgencyClients/StaffingAgencyClientRelationLabel.vue'

const StaffingAgencyClientRelationColumn = graphql(`
  fragment StaffingAgencyClientRelationColumn on SupplierClient {
    id
    isDirect
    managingCompany {
      id
      name
      avatar
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof StaffingAgencyClientRelationColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(StaffingAgencyClientRelationColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
